import { Injectable } from '@angular/core';
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, mergeMap, take, tap } from 'rxjs/operators';
import { AuthService, UserSession } from 'src/app/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private authService: AuthService) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return from(this.authService.userSession()).pipe(
			take(1),
			tap((userSession: UserSession) =>
				this.authService.resetLogoutTimer(userSession)
			),
			map((userSession: UserSession): HttpRequest<any> => {
				return userSession
					? req.clone({
							setHeaders: { Authorization: `Bearer ${userSession.token}` },
						})
					: req;
			}),
			mergeMap((it: HttpRequest<any>) => next.handle(it)),
			catchError((error: HttpErrorResponse) => {
				if (error.status === 401) {
					this.authService.logout('Please login again.').then(() => {});
				}

				return throwError(() => error);
			})
		);
	}
}
